import React from 'react';

import { AsaphButton } from '@/components/shared/Button';
import { FormInput, TextInput } from '@/components/shared/Inputs';
import { PasswordInput } from '@/components/shared/Inputs/Password';
import { Loader } from '@/components/shared/Loader';
import { useEnvironment } from '@/providers/EnvironmentProvider';
import { FormHelperText } from '@material-ui/core';
import { useQuery } from '@tanstack/react-query';
import axios, { AxiosError } from 'axios';
import { Formik } from 'formik';
import { useParams } from 'react-router';
import * as Yup from 'yup';

import styles from '../../Login/LoginPage.module.scss';

const signUpValidationSchema = Yup.object().shape({
	email: Yup.string()
		.email('Must be a valid email address')
		.required('Email address is required'),
});

const EmailForm: React.FC<{ onChange: (email: string) => void }> = ({
	onChange,
}) => {
	const {
		api: { url },
	} = useEnvironment();

	return (
		<Formik
			key="asaphSignUn"
			initialValues={{
				email: '',
			}}
			validationSchema={signUpValidationSchema}
			onSubmit={async (values, formikHelpers) => {
				try {
					await axios.post(`${url}/link/join`, {
						email: values.email,
					});
					onChange(values.email);
				} catch (err) {
					let error = 'Something went wrong';
					if (err instanceof AxiosError) {
						if (err.status === 400) {
							error = 'Invalid email';
						}
					}
					formikHelpers.setErrors({
						email: error,
					});
				}
				formikHelpers.setSubmitting(false);
			}}
		>
			{({
				handleSubmit,
				handleChange,
				values,
				isSubmitting,
				touched,
				errors,
			}) => (
				<form onSubmit={handleSubmit} id="asaphSignIn">
					<h1 className={styles.heading}>Log in/Sign Up</h1>

					<div className="vsb-8" />
					<FormInput
						id="email"
						name="email"
						type="email"
						className={styles.input}
						placeholder="name@email.com"
						onChange={handleChange}
						value={values.email}
						fullWidth
					/>

					<div className="vsb-8" />
					<p className={styles.text}>
						We'll send you a one-time code to confirm your address
					</p>

					<div className="vsb-8" />
					<AsaphButton
						label="Continue"
						type="submit"
						color="blue"
						fullWidth
						disabled={isSubmitting}
					/>
					<div className="vsb-20">
						{!!errors.email && touched.email && (
							<FormHelperText
								error={true}
								classes={{
									root: 'authentication-error-text',
								}}
							>
								{errors.email}
							</FormHelperText>
						)}
					</div>
				</form>
			)}
		</Formik>
	);
};

export default EmailForm;
